/*
** abstract Scene -- superclass for all the squish scenes, which live inside the WaveView
** Copyright (C) 2021-2026 Tactile Interactive, all rights reserved
*/

let tracePaint = false;

// Each abstractScene subclass is a definition of a kind of picture or scene;
// one per each kind of scene. Each drawing is a definition of a part of a scene
// (usually drawn with 1 GL program).  A Scene has one or more drawings in it.  There's always a  compoent with a canvas that hosts an instance of the Scene and is a React component enclosing
// the canvas.  (example WaveView, SetWaveTab)

/* ****************************************  */


// This is the superclass of all scene defs; with common webgl and space plumbing.
// sceneName is not the sceneClassName, which is one of flatScene, garlandView, ...
// there should be ONE of these per canvas, so each WaveView should have 1.
export class abstractScene {

	/* ************************************************** construction */
	// A scene is always constructed with args sceneName, ambiance, space
	// The scene constructor sometimes ignores the space but it's passed anyway.
	// paintingNeeds contains stuff to send to webgl; object freeform.

	// sceneName: personal name for the scene instance, for error msgs
	// ambiance.canvas and .gl: real <canvas> DOM element, after it's been created by React
	// paintingNeeds: on WaveView, WaveViista, or similar hi-level component
	// passed down thru props to drawingScene then ultimately draw
	constructor(sceneName, ambiance, paintingNeeds, space) {
		this.sceneName = sceneName;
		this.canvas = ambiance.canvas;
		this.gl = ambiance.gl;
		this.tagObject = ambiance.tagObject;
		if (!paintingNeeds || !space) throw `paintingNeeds ${paintingNeeds}  or space ${space} is null`;
		this.paintingNeeds = paintingNeeds;  // might be undef
		this.space = space;  // might be undef
		if (! this.canvas) throw new Error(`abstractScene: being created without canvas`);

		// all of the drawings in this scene
		// they get prepared, and drawn, in this same order
		this.drawings = [];
	}

	// the final call to set it up does all sceneClassName-specific stuff
	// other subclassers override what they want
	completeScene() {
		this.compileShadersOnDrawings();
		this.createVariablesOnDrawings();

		// call again if canvas outer dimensions change  WRONG doesn't do bumpers
		// No!  difft for each drawing
		// this.gl.viewport(0, 0, this.canvas.width, this.canvas.height);

		if (tracePaint)
			console.log(`🦊 abs completeScene() width=${this.canvas.width}, height=${this.canvas.height},`);

		this.drawAllDrawings(this.canvas.width, this.canvas.height, this.paintingNeeds);
	}

	/* ****************************************** Shader s */
	// this does shaders and inputs, integrating thru the list of drawings
	// see abstractDrawing
	// drawings have their glsl scripts in their constructors
	compileShadersOnDrawings() {
		this.drawings.forEach(drawing => {
			drawing.compileProgram();
		});
	}

	/* ************************************************** buffers & variables */

	// go and call createVariables on each of the drawings.
	// Should be done ONCE when canvas & avatar are created, or recreated.
	// NOT upon every repaint!!
	createVariablesOnDrawings() {
		this.drawings.forEach(drawing => {
			// a drawing's reloadVarable() methods might set it
			drawing.skipDrawingCuzErr = null;
			drawing.createVariables();
		});
	}


	/* ************************************************** drawing */

	// this should be made pluggable at some point...
	drawBackground() {
		const gl = this.gl;

		// solid opaque black.  Erase for both 2d and 3d.
		// debugging ... gl.clearColor(.8, .6, .4, 1);
		gl.clearDepth(1);  // default anyway
		gl.clearColor(0, 0, 0, 1);
		gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
	}

	drawAllDrawings(width, height) {
		if (tracePaint) console.log(`🦊 abs drawAllDr width=${width}, height=${height},`);
		if (!width || !height) debugger;

		// not specific to any drawing; I guess it's kindof a drawing itself
		this.drawBackground();

		this.drawings.forEach(drawing => {
			// individual uniforms (and others?) can abort drawing if they're like NaN etc
			drawing.skipDrawingCuzErr = null;

			// must useProgram cuz we're going thru a loop of different drawings/programs
			this.gl.useProgram(drawing.program);
			drawing.drawVariables.forEach(v => v.reloadVariable());

			if (!drawing.skipDrawingCuzErr)
				drawing.draw(width, height, this.paintingNeeds);
		});
	}
}
export default abstractScene;

